export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border">
      <div className="mx-auto max-w-4xl px-8 py-6 flex justify-between items-center">
        <p className="text-[11px] text-text-muted tracking-wider">© {currentYear} Maxim Kraft</p>
        <p className="text-[11px] text-text-faint tracking-caps uppercase">maximkraft.com</p>
      </div>
    </footer>
  );
}
